import { useState, useEffect, Suspense } from "react";

import { useLayout } from "@hooks/useLayout";

import Router from "./router/Router";
import { getRoutes, Routes } from "./router/routes";

console.info(`ENVIRONMENT
repository  = ${process.env.REACT_APP_BASENAME}
environment = ${process.env.REACT_APP_ENV}
server      = ${process.env.REACT_APP_MIDDLEWARE_API_URL}
`);

const App = () => {
  const [allRoutes, setAllRoutes] = useState(Routes);

  const { layout } = useLayout();

  useEffect(() => {
    setAllRoutes(getRoutes(layout));
  }, [layout]);

  return (
    <Suspense fallback={null}>
      <Router allRoutes={allRoutes} />
    </Suspense>
  );
};

export default App;